import { configureStore } from "@reduxjs/toolkit";
import cartReducer from '../Slices/cart/Cart.js'
import wishReducer from '../Slices/cart/Wish.js'
import authReducer from '../Slices/cart/auth/Auth.js'
import constantsReducer from '../Slices/cart/auth/Contants.js'


/*
const rootReducer = combineReducers({
   
    
  });
  */
export const Store=configureStore({
reducer:{
     wish:wishReducer,
    cart: cartReducer,
    auth:authReducer,
    constants:constantsReducer
    
  
    
}

})